import { useEffect, useState, useRef } from "react";
import chevronDown from "../../assets/vw/svg/chevron-down.svg";
import chevronUp from "../../assets/vw/svg/chevron-up.svg";

const Dropdown = ({
  menu,
  title,
  handleOptionSelected,
  itsCardsView,
  inputField,
  errors,
  required,
  disabled
}) => {
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const filtroRef = useRef();
  const [showData, setShowData] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const closeFiltro = (e) => {
        if (!filtroRef.current.contains(e.target)) {
          setIsOptionsOpen(false);
        }
      };
      window.addEventListener("mouseup", closeFiltro);
      return () => window.removeEventListener("mouseup", closeFiltro);
    }
  }, [isOptionsOpen]);

  useEffect(() => {
    const index = menu.findIndex((element) => element === inputField?.value);
    if (index >= 0) setSelectedOption(index);
  }, [inputField]);

  function setProfileVisibility() {
    if (disabled) return; // No hacer nada si está deshabilitado
    setShowData(!showData);
  }

  const toggleOptions = () => {
    if (disabled) return; // No hacer nada si está deshabilitado
    setIsOptionsOpen(!isOptionsOpen);
  };

  const handleKeyDown = (e, index, option) => {
    console.log(e)
    switch (e.key) {
      case " ":
      case "SpaceBar":
      case "Enter":
        e.preventDefault();
        onclickOptionSelected(index, option);
        break;
      default:
        break;
    }
  };

  const onclickOptionSelected = (index, option) => {
    if (disabled) return; 
    setSelectedOption(index);
    setIsOptionsOpen(false);
    setShowData(!showData);
    if (handleOptionSelected) handleOptionSelected(option);
    if (inputField?.onChange) inputField.onChange(option);
  };

  const showSelectedOption = () => {
    if (inputField?.value) {
      return inputField.value;
    } else if (selectedOption !== null) {
      return menu[selectedOption];
    } else {
      return title;
    }
  };

  const TitleSplitted = ({palabra = ""}) => {
    let firstWord = "";
    let secondWord = "";
    let showWord = false;

    if (palabra) {
      firstWord = palabra.split(" ")[0];
      secondWord = palabra.split(" ")[1];
    } else {
      const selectedOption = showSelectedOption();
      firstWord = selectedOption.split(" ")[0];
      secondWord = selectedOption.split(" ")[1];
      if (!secondWord) {
        showWord = true;
      }
    }

    return (
        <>
          <span className={"mr-1 " + (showWord ? "show_word" : "not_show_word")}>{firstWord}</span>
          {secondWord && <span>{secondWord}</span>}
        </>
    );
  }

  return (
    <div className={`dropdown_vw`} ref={filtroRef}>
      <div className={`containerMenu`}>

        <div
            className="btn"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            onClick={toggleOptions}
            disabled={disabled}
        >
          <button
              type="button"
              className={`chevron_dropdown`}
              onClick={() => setProfileVisibility()}
              aria-expanded={showData}
          >
            {showData === false ? <img src={chevronUp} alt="before"/> : <img src={chevronDown} alt="before"/>}
          </button>


          <div className={`content`}> {selectedOption !== null ? <TitleSplitted/> : <TitleSplitted palabra={title}/>}</div>
        </div>


        <ul
            className={`dropdown-menu options ${isOptionsOpen ? "show" : ""}`}
            role="listbox"
          tabIndex={-1}
        >
          {menu.map((option, index) => (
            <li
              id={option}
              role="option"
              aria-selected={selectedOption === index}
              tabIndex={0}
              key={index}
              onClick={() => onclickOptionSelected(index, option)}
            >
                <label className="px-2">{option}</label>
              
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Dropdown;
